import { Typography, Row } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import AgreeCheck from '../../../components/AgreeCheck';
import { FONT } from '../../../styles/color';

interface ConsentsProps {
  // eslint-disable-next-line no-unused-vars
  setIsAgreedThePrivacyPolicy: (value: boolean) => void;
}

const Consents: FC<ConsentsProps> = ({ setIsAgreedThePrivacyPolicy }) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 768px)',
  });
  const [isAgreedTCPrivacyPolicy, setIsAgreedTCPrivacyPolicy] = useState(false);
  const [isAgreedRiskAgreement, setIsAgreedRiskAgreement] = useState(false);
  const [isAgreedTelecareTnC, setIsAgreedTelecareTnC] = useState(false);
  const [isAgreedAmplarTnC, setIsAgreedAmplarTnC] = useState(false);
  const [isAgreedHealthcareRights, setIsAgreedHealthcareRights] = useState(false);

  useEffect(() => {
    setIsAgreedThePrivacyPolicy(isAgreedTCPrivacyPolicy && isAgreedRiskAgreement && isAgreedTelecareTnC && isAgreedAmplarTnC && isAgreedHealthcareRights);
  }, [isAgreedTCPrivacyPolicy, isAgreedRiskAgreement, isAgreedTelecareTnC, isAgreedAmplarTnC, isAgreedHealthcareRights, setIsAgreedThePrivacyPolicy]);

  return (
    <div style={{ marginBottom: '50px' }}>
      <Typography.Title
        level={3}
        style={{ marginBottom: isMobile ? '10px' : '20px', textAlign: 'center', color: FONT, fontSize: isMobile ? '18px' : '24px' }}
      >
        Privacy and Terms
      </Typography.Title>

      <Row style={{ marginBottom: '30px' }}>
        <Typography.Text style={{ marginBottom: '10px', textAlign: 'left', fontSize: isMobile ? '16px' : '18px' }}>
          <strong style={{ color: FONT }}>Telecare Privacy Collection Notice</strong>
          : Telecare Australia Pty Ltd (ABN 37 632 722 911) (“Telecare”) collects your personal information in order to
          provide the services. Without this information, Telecare cannot provide services. For more details on
          accessing or correcting your information and our complaint procedures, visit Telecare’s Privacy Policy. The
          Telecare Privacy Policy provides more information about how Telecare may disclose personal information to
          other entities. Telecare does not share personal information with Amplar Virtual Health except in the limited
          circumstances of reporting incidents or otherwise where necessary for Amplar Virtual Health to comply with its
          legal obligations and administer the services. Such information will be handled in accordance with Amplar
          Virtual Health’s privacy policy available at
          <a
            target="_blank"
            href="https://www.amplarhealth.com.au/privacy"
            rel="noreferrer"
          >
            {' Amplar | Policy'}
          </a>
          .
        </Typography.Text>
      </Row>

      <Row style={{ marginBottom: '30px' }}>
        <Typography.Text style={{ marginBottom: '10px', textAlign: 'left', fontSize: isMobile ? '16px' : '18px' }}>
          1) I understand the Virtual Psychology Clinic is not a crisis service. If you are experiencing an urgent or
          life-threatening situation, call Triple Zero (000) or visit the emergency department at your local hospital.
        </Typography.Text>
        <AgreeCheck
          isAgreed={isAgreedRiskAgreement}
          setIsAgreed={setIsAgreedRiskAgreement}
        />
      </Row>

      <Row style={{ marginBottom: '30px' }}>
        <Typography.Text style={{ marginBottom: '10px', textAlign: 'left', fontSize: isMobile ? '16px' : '18px' }}>
          2) Telecare Privacy Policy:
          <a
            target="_blank"
            href="https://www.telecare.com.au/privacy-policy"
            rel="noreferrer"
          >
            {' Telecare | Privacy Policy'}
          </a>
        </Typography.Text>
        <AgreeCheck
          isAgreed={isAgreedTCPrivacyPolicy}
          setIsAgreed={setIsAgreedTCPrivacyPolicy}
        />
      </Row>

      <Row style={{ marginBottom: '30px' }}>
        <Typography.Text style={{ marginBottom: '10px', textAlign: 'left', fontSize: isMobile ? '16px' : '18px' }}>
          3) Telecare T&Cs:
          <a
            target="_blank"
            href="https://www.telecare.com.au/termsandconditions"
            rel="noreferrer"
          >
            {' Terms & Conditions'}
          </a>
        </Typography.Text>
        <AgreeCheck
          isAgreed={isAgreedTelecareTnC}
          setIsAgreed={setIsAgreedTelecareTnC}
        />
      </Row>

      <Row style={{ marginBottom: '30px' }}>
        <Typography.Text style={{ marginBottom: '10px', textAlign: 'left', fontSize: isMobile ? '16px' : '18px' }}>
          4) Amplar T&Cs:
          <a
            target="_blank"
            href="https://virtualpsychology.amplarhealth.com.au/terms-and-conditions"
            rel="noreferrer"
          >
            {' Terms & Conditions'}
          </a>
        </Typography.Text>
        <AgreeCheck
          isAgreed={isAgreedAmplarTnC}
          setIsAgreed={setIsAgreedAmplarTnC}
        />
      </Row>

      <Row>
        <Typography.Text style={{ marginBottom: '10px', textAlign: 'left', fontSize: isMobile ? '16px' : '18px' }}>
          5) Healthcare Rights:
          <a
            target="_blank"
            href="https://www.safetyandquality.gov.au/sites/default/files/2025-10/australian-charter-of-healthcare-rights-a4-poster.pdf"
            rel="noreferrer"
          >
            {' Australian Charter of Healthcare Rights'}
          </a>
        </Typography.Text>
        <AgreeCheck
          isAgreed={isAgreedHealthcareRights}
          setIsAgreed={setIsAgreedHealthcareRights}
        />
      </Row>
    </div>
  );
};

export default Consents;
